<mat-toolbar class="gsp-toolbar toolbar-height">
  <ng-content></ng-content>
</mat-toolbar>